import { render, staticRenderFns } from "./pay-result.vue?vue&type=template&id=38144332&scoped=true"
import script from "./pay-result.vue?vue&type=script&lang=js"
export * from "./pay-result.vue?vue&type=script&lang=js"
import style0 from "./pay-result.vue?vue&type=style&index=0&id=38144332&prod&lang=scss&scoped=true"
import style1 from "./pay-result.vue?vue&type=style&index=1&id=38144332&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38144332",
  null
  
)

export default component.exports